import { environmentHttpClient } from "client/Api/httpClient";

export enum UserGroupPermission {
	NotSet = 0,
	Allowed = 1,
	Denied = 2
}

export type UserGroupPermissionsModel = {
	canCreateApps: UserGroupPermission;
	canCreateSharedGroups: UserGroupPermission;
	canCreateAnnouncementsAndCategories: UserGroupPermission;
	canEditOwnWorkspace: UserGroupPermission;
	canMakeUserRequests: UserGroupPermission;
	canCreateKnowledgeItemsAndCategories: UserGroupPermission;
	canCreateEventsAndCategories: UserGroupPermission;
	canCreateHubTemplates: UserGroupPermission;
	canUploadAndManageAppIcons: UserGroupPermission;
	canCreateAndManageSpaces: UserGroupPermission;
	canManageAllApps: UserGroupPermission;
	canManageBillingModulesAndLicenses: UserGroupPermission;
	canManageSharedTileGroups: UserGroupPermission;
	canManageUsersGroupsAndUserProvisioning: UserGroupPermission;
	canSendDirectPopups: UserGroupPermission;
	canCreateAndManageCommunitiesAndCommunityPosts: UserGroupPermission;
	canManageBranding: UserGroupPermission;
	canCreateAndManageIntegrationBuilderIntegrations: UserGroupPermission;
	canViewAnalytics: UserGroupPermission;
};

export type DefaultUserGroupPermissionsPageModel = {
	permissions: UserGroupPermissionsModel;
};

export function getViewModel(
	signal?: AbortSignal
): Promise<DefaultUserGroupPermissionsPageModel> {
	return environmentHttpClient.get<DefaultUserGroupPermissionsPageModel>(
		`/UiApi/UserGroupPermissions`,
		undefined,
		{ signal }
	);
}

export function save(
	model: UserGroupPermissionsModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		`/UiApi/UserGroupPermissions`,
		model,
		{ signal }
	);
}
